import { ref } from 'vue'

import { sessionApi } from '@/entities/session'
import { userDataApi, userDataModel } from '@/entities/user-data'
import { type CsrfTokenResponse, isErrorResponse } from '@/shared/api'
import { CSRF_KEY, useConfig } from '@/shared/config'
import { useLocalStorage } from '@/shared/lib/browser'

const secondsBetweenRequest = ref(0)

export function useModel() {
    const userDataStore = userDataModel.useModel()
    const isLoading = ref(false)

    const { config } = useConfig()

    const { r$ } = userDataStore

    async function sendOtp() {
        isLoading.value = true
        const { data, response } = await sessionApi.sendOtp({
            phone: r$.phone.$value?.replace(/\D/g, '') || '',
            sector: config.sector,
            signature: config.signature,
        })

        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) return false
        secondsBetweenRequest.value = data?.seconds_between_requests || 30

        return true
    }

    async function getCsrf() {
        const { setLSValue } = useLocalStorage<CsrfTokenResponse>(CSRF_KEY, {
            headerName: '',
            parameterName: '',
            token: '',
        })

        const response = await sessionApi.getCsrf()

        if (!response || !response.token) return false

        setLSValue(response)
        return true
    }

    async function login(code: string) {
        isLoading.value = true
        const { data, response } = await sessionApi.login({
            code,
            phone: r$.phone.$value?.replace(/\D/g, '') || '',
        })

        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) return false

        await getCsrf()
        return true
    }

    async function changeStatusSubscription(methodId: number, status: boolean) {
        isLoading.value = true
        const { data, response } = await userDataApi.changeStatusSubscription(methodId, status)
        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) return false
        return true
    }

    async function createSbpSubscription() {
        isLoading.value = true
        const { data, response } = await userDataApi.createSbpSubscription()
        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) return false
        const redirectUrl = data?.redirect_url
        return redirectUrl
    }

    return {
        changeStatusSubscription,
        createSbpSubscription,
        getCsrf,
        isLoading,
        login,
        secondsBetweenRequest,
        sendOtp,
    }
}
